export class Params {
	referenceId: number;
	type: ParamType;
	key: ParamKey;
	value: any;

	constructor(obj: any = { }) {
		Object.assign(this, obj);
	}
}

export enum ParamType {
	STORE = "STORE",
	PLACE = "PLACE"
}

export enum ParamKey {
	MINIMUM_DELIVERY_PRICE = "MINIMUM_DELIVERY_PRICE",
	MANAGER_BY_PLACE = "MANAGER_BY_PLACE",
	ALLOW_ORDER_RESERVATION = "ALLOW_ORDER_RESERVATION",
	ALLOW_ONLY_ORDER_RESERVATION = "ALLOW_ONLY_ORDER_RESERVATION"
}



// WEBPACK FOOTER //
// ./src/app/shared/models/params.model.ts